export const getTypesOfParameters = (parameters: Dic<any>) => {
  const parametersTypes: Dic<any> = {};
  if (!!parameters) {
    Object.entries(parameters)?.forEach(
      (parameter: any) => (parametersTypes[parameter[0]] = parameter[1].type)
    );
  }
  return parametersTypes;
};
